import { Text } from '@chakra-ui/react'
import React from 'react'

import { Checkbox } from '@mangovoice/mango-ui'

export interface NodeCheckboxProps {
  label: string
  checked?: boolean
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const stopPropagation = (e: React.SyntheticEvent) => e.stopPropagation()

/**
 * Shared `Checkbox` adapted for switchboard nodes: keeps pointer and key
 * events from reaching the React Flow canvas and exposes a change-event style
 * `onChange` callback.
 */
export const NodeCheckbox: React.FC<NodeCheckboxProps> = ({
  label,
  checked,
  onChange,
}) => {
  const handleCheckedChange = (details: {
    checked: boolean | 'indeterminate'
  }) => {
    onChange?.({
      target: { checked: details.checked === true },
    } as React.ChangeEvent<HTMLInputElement>)
  }

  return (
    <Checkbox
      className="nodrag"
      size="sm"
      gap={1.5}
      checked={checked === true}
      onCheckedChange={handleCheckedChange}
      onMouseDown={stopPropagation}
      onPointerDown={stopPropagation}
      onClick={stopPropagation}
      onKeyDown={stopPropagation}
    >
      <Text as="span" fontSize="xs" color="fg.default">
        {label}
      </Text>
    </Checkbox>
  )
}
